import { render, staticRenderFns } from "./IotModelPointsModal.vue?vue&type=template&id=0704270a&"
import script from "./IotModelPointsModal.vue?vue&type=script&lang=js&"
export * from "./IotModelPointsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports